export default __webpack_public_path__ + "f26c02a8264dc37e26f4a9cf7fabefd3.jpg";